// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1m8b8","boxTitle":"Qualiphy_boxTitle__2d0Ib","box":"Qualiphy_box__19XoQ","toggleWrap":"Qualiphy_toggleWrap__3Vq7S"};